export default __webpack_public_path__ + "static/media/user.cd143eea.svg";